import EventAttachmentForm from "./event-attachment-form";

export default EventAttachmentForm;